import { useBuildArtifacts, useBuildChecks, useBuildEnv, useBuildEvents } from '@/api/hooks';

/** The four lists behind the detail tabs. They load in parallel with the build itself; the env snapshot only while its tab is open. */
export function useBuildTabQueries(buildId: string, tab: string) {
  const events = useBuildEvents(buildId);
  const checks = useBuildChecks(buildId);
  const artifacts = useBuildArtifacts(buildId);
  const env = useBuildEnv(buildId, tab === 'env');
  return { events, checks, artifacts, env };
}

export type BuildTabQueries = ReturnType<typeof useBuildTabQueries>;
